/**
 * Translate a key.
 */
export function translateToString(translation, lang, params) {
    const result = translation(lang, params);
    if (Array.isArray(result)) {
        return result.join('');
    }
    return result || '';
}
//# sourceMappingURL=translateToString.js.map